import TrackingProvider from './TrackingProvider';

class GoogleAnalytics extends TrackingProvider {
    public initialize(trackingIds: string) {
        const ids = this.extractCleanTrackingIds(trackingIds);
        const debug = this.debug.bind(this);

        if (!this.isActive && ids.length > 0) {
            this._trackingIds = ids;

            window.dataLayer = window.dataLayer || [];
            /* eslint-disable */
            window.gtag = function () {
                window.dataLayer.push(arguments);
                debug('gtag:', ...arguments);
            };
            /* eslint-enable */
            this.loadScript(`https://www.googletagmanager.com/gtag/js?id=${this.firstTrackingId}`);
            this._active = true;

            this.gtag('js', new Date());
            this.trackingIds.forEach((id) => this.gtag('config', id));
        }

        return this;
    }

    // Do not use this method. Use static GoogleTagManager.gtag instead
    public gtag: Gtag.Gtag = (...args) => {
        window.gtag?.(...args);
    };
}

export default new GoogleAnalytics().initialize(process.env.MIX_GA_TRACKING_ID);
